import { DateHelper } from '../utils/DateHelper';

export class HarshEvent {
  public uid: number;
  public uid_device: number;
  public uid_driver: number;
  public uid_trip: number;
  public stamp: number;
  public timestamp: number;
  public speed_cat: number;
  public event_kind: number;
  public longitude: number;
  public latitude: number;
  public text: dictionnaryHarsh;

  public constructor(harshBack?) {
    this.uid = harshBack?.uid;
    this.uid_device = harshBack?.uid_device;
    this.uid_driver = harshBack?.uid_driver;
    this.uid_trip = harshBack?.uid_trip;
    this.stamp = harshBack?.stamp;
    this.timestamp = new DateHelper(this.stamp).timestamp();
    this.speed_cat = harshBack?.speed_cat;
    this.event_kind = harshBack?.event_kind;
    this.longitude = harshBack?.longitude;
    this.latitude = harshBack?.latitude;
    this.text = this.setTextForHarsh(harshBack?.event_kind, harshBack?.speed_cat);
  }

  setTextForHarsh(event_kind: number, speed_cat: number): dictionnaryHarsh {
    let text: dictionnaryHarsh = {
      fr: '',
      en: '',
    };
    if (event_kind === 0) {
      text.fr += 'Freinage';
      text.en += 'Braking';
    } else if (event_kind === 1) {
      text.fr += 'Accélération';
      text.en += 'Acceleration';
    }
    if (speed_cat === 1) {
      text.fr += ' à basse vitesse';
      text.en += ' low speed';
    } else if (speed_cat === 2) {
      text.fr += ' à moyenne vitesse';
      text.en += ' medium speed';
    } else if (speed_cat === 3) {
      text.fr += ' à forte vitesse';
      text.en += ' high speed';
    }
    return text;
  }
}
interface dictionnaryHarsh {
  fr: string;
  en: string;
}
